























































import { defineComponent } from "@nuxtjs/composition-api";
import { useGtm } from "~/composables";
import { startsWith } from "lodash-es";

export default defineComponent({
  name: "MenuList",
  components: {},
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    historyMenu: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { eventCustomlinksInteracted } = useGtm();

    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };

    return {
      navigationTracking,
      startsWith,
      httpText: 'https://',
    };
  },
});
